import request from '@/ajax/index.js'
/**
 * 分享帖子
 */	//TODO::
 export function shareArticle(query) {
	return request('/article/shareArticle', query);
}


//分享游戏
export function shareGame(query) {
	return request('/game/shareGame', query);
}
